import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { slug } from "../../lib/site";

export default function NavDropdown({ item, className, style, prefix }) {
  const [rect, setRect] = useState(null);
  const btn = useRef(null);
  const timer = useRef(null);
  const { pathname, hash } = useLocation();

  const show = () => {
    clearTimeout(timer.current);
    setRect(btn.current.getBoundingClientRect());
  };
  const hide = () => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setRect(null), 160);
  };

  useEffect(() => setRect(null), [pathname, hash]);
  useEffect(() => {
    if (!rect) return;
    const close = (e) => (e.type === "keydown" ? e.key === "Escape" : !btn.current.contains(e.target) && !e.target.closest("[data-nav-dd]")) && setRect(null);
    const reset = () => setRect(null);
    document.addEventListener("keydown", close);
    document.addEventListener("mousedown", close);
    window.addEventListener("scroll", reset, { passive: true });
    return () => {
      document.removeEventListener("keydown", close);
      document.removeEventListener("mousedown", close);
      window.removeEventListener("scroll", reset);
    };
  }, [rect]);

  return (
    <>
      <button ref={btn} type="button" onClick={() => (rect ? setRect(null) : show())} onMouseEnter={show} onMouseLeave={hide}
        aria-expanded={!!rect} data-testid={`${prefix}-${slug(item.label)}`} className={`${className} inline-flex items-center gap-1`} style={style}>
        {item.label}
        <ChevronDown size={11} className="transition-transform duration-300" style={{ transform: rect ? "rotate(180deg)" : "none" }} />
      </button>
      {rect && createPortal(
        <div data-nav-dd onMouseEnter={show} onMouseLeave={hide} data-testid={`${prefix}-${slug(item.label)}-menu`}
          className="fixed z-[80] min-w-[230px] py-3 rounded-2xl"
          style={{ top: rect.bottom + 12, left: rect.left + rect.width / 2, transform: "translateX(-50%)", background: "rgba(6,9,22,0.94)", border: "1px solid rgba(233,214,162,0.16)", backdropFilter: "blur(16px)", boxShadow: "0 18px 40px rgba(0,0,0,0.5)", animation: "msFadeIn 220ms ease forwards" }}>
          {item.children.map((c) => (
            <Link key={c.label} to={c.href} onClick={() => setRect(null)} data-testid={`${prefix}-dd-${slug(c.label)}`}
              className="block px-6 py-2.5 text-[10.5px] tracking-[0.22em] uppercase whitespace-nowrap transition-colors hover:text-white hover:bg-white/[0.03]" style={{ color: "#c8bd9a" }}>
              {c.label}
            </Link>
          ))}
        </div>,
        document.body
      )}
    </>
  );
}
